import { render, staticRenderFns } from "./BrokerFirmNotesList.vue?vue&type=template&id=69b96adc&scoped=true"
import script from "./BrokerFirmNotesList.vue?vue&type=script&lang=js"
export * from "./BrokerFirmNotesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b96adc",
  null
  
)

export default component.exports